import React from 'react';
import './Neuron.css';
import { Input } from '../utils/Input'
import { COLORS } from '../utils/Color'


export class NetRenderer extends React.Component {


	constructor(props) {
		super(props)
		this.matrixH = 23
		this.neuronW = 40
		this.space = this.neuronW + 5
		this.headerH = 60
		this.maxNeurons = 0
		this.inputW = 50
		this.maxOutputIndex = -1

		this.props.app.netRenderer = this

		this.state = {
			precision: 2,
			matrixW: 44
		}
	}


	componentDidMount() {
		this.props.app.netRenderer = this
	}


	// miscellaneous --------------------------------------------------------------------------------


	getHighestOutputIndex() {
		let layer = this.props.net.layers[this.props.net.layers.length - 1];
		let max = 0;
		for (let i = 0; i < layer.neurons.length; i++) {
			if (layer.neurons[i] > layer.neurons[max]) {
				max = i;
			}
		}
		return max;
	}

	setPrecision(p) {
		this.setState({
			precision: p,
			matrixW: p === 1 ? 36 : 44
		})
	}


	getMaxNeurons() {
		let max = 0;
		for (let i = 0; i < this.props.net.layers.length; i++) {
			max = Math.max(this.props.net.layers[i].neurons.length, max);
		}
		return max;
	} 	


	getWeightColor(w) {
		let rgb = []
		let top = 220
		rgb[0] = w < 0 ? (top - Math.abs(w) * 6) : (w > 10 ? 0 : top - w * 20)
		rgb[1] = w < 0 ? (w < -9 ? 0 : top - Math.abs(w) * 22) : (220 - Math.abs(w) * 6)
		rgb[2] = w < 0 ? (w < -9 ? 0 : top - Math.abs(w) * 22) : (w > 10 ? 0 : top - w * 20)
		return rgb
	}


	getLayerLabel(layerNumber) {
		if (layerNumber === 0)
			return "Input"
		else if (layerNumber === this.props.net.layers.length - 1)
			return "Output"
		return "Hidden " + layerNumber
	}



	renderToggleShow(key, showCloseButton) {
		if (showCloseButton) {
			if (key[0] === 'G') {
				return (
					<div 
						className = "NetClose" 
						onClick = {() => this.props.app.setState({showGraph: !this.props.app.state.showGraph})}>
						&#10005;
					</div>
				)
			}
			if (key[0] === 'M') {
				return (
					<div 
						className = "NetClose" 
						onClick = {() => this.props.app.setState({showMatrix: !this.props.app.state.showMatrix})}>
						&#10005;
					</div>
				)
			}
		}
	}


	renderToggleBias(layerNumber, key) {
		if (key.substring(0, 14) === "HEADER_WEIGHTS" && layerNumber > 1) {
			return (
				<div 
					className = "ToggleBias" 
					onClick = {() => this.props.app.setState({showBias: !this.props.app.state.showBias})}>
						{this.props.app.state.showBias ? "\u25C0" : "\u25B6"}&nbsp;Bias
				</div>			
			)
		}
	}


	renderPrecision(layerNumber, key) {
		if (key.substring(0, 14) === "HEADER_WEIGHTS" && 
			layerNumber >= 1 && 
			this.props.net.layers[layerNumber - 1].neurons.length >= 3) {
			return (
				<div className = "PrecisionFrame">
					<div className = "PrecisionText">
						Precision
					</div>
					<div className = "PrecisionData">
						<div className = "PrecisionMinus" onClick = {() => this.setPrecision(1)}>
							<img src = {"l-arr.png"} height = '14px' alt = '-'></img>
						</div>
						<div className = "PrecisionValue">
							{this.state.precision}
						</div>
						<div className = "PrecisionMinus" onClick = {() => this.setPrecision(2)}>
							<img src = {"r-arr.png"} height = '14px' alt = '-'></img>
						</div>
					</div>
				</div>			
			)
		}
	}


	renderLayerLabel(label) {
		return (
			<div className = "LayerHeader">
				{label}
			</div>			
		)
	}


	renderBack(key, xpos, width, height, label, layerNumber, isLayer, showAddButton, showCloseButton) {
		return (
			<div 
				className = "LayerBack" 
				key = {key}
				style = {{
					width: width + 'px', 
					height: height + 'px', 
					left: xpos + 'px',
					borderLeft: (layerNumber === 0 ? "0px" : "0.5px solid #cccccc"),
					borderTop: "0.5px solid #cccccc"
				}}>
				{this.renderToggleShow(key, showCloseButton)}
				{this.renderLayerLabel(label)}
				{this.renderToggleBias(layerNumber, key)}
				{this.renderPrecision(layerNumber, key)}
				{this.renderLayerAction(layerNumber, isLayer, showAddButton)}
			</div>
		)
	}


	renderLayerAction(layerNumber, isLayer, showAddButton) {
		if (isLayer) {
			if (layerNumber === 0 || layerNumber === this.props.net.layers.length - 1) {
				return (
					<div className = "LayerAction">
						<div className = "Inner" style = {{paddingTop: '2px'}}>
							{this.props.net.layers[layerNumber].neurons.length}
						</div>
						<div className = "InnerBelow" style = {{marginTop: "-3px"}}>
							Neurons
						</div>
					</div>
				)
			}
			else {
				return (
					<div className = "LayerAction">
						<div className = "Inner">
							<Input 
								className = "Input"
								text = {this.props.net.layers[layerNumber].neurons.length + ""}
								readOnly = {false}
								store = {(num) => this.props.app.updateNetLayer(layerNumber, num)}
								allowEditOnClick = {true}
								/>
								
							<div className = "InnerBelow">
								Neurons
							</div>
							<div className = "NetButton" onClick = {(num) => this.props.app.deleteNetLayer(layerNumber, num)}>
								&#10005;
							</div>
						</div>
					</div>
				)
			}
		}
		else {
			if (showAddButton && layerNumber === this.props.net.layers.length - 1) {
				return (
					<div className = "AddLayer">
						<div className = "AddLayerText">
							Add
						</div>
						<div className = "AddLayerText2">
							Layer
						</div>
						<div 
							className = "NetButton" 
							style = {{marginTop: "3px", fontSize: "13pt"}}
							onClick = {() => this.props.app.addNetLayer(1)}>
							+
						</div>
					</div>
				)
			}
		}
		return null
	}


	// render expected --------------------------------------------------------------------------------


	renderGraphExpected(expected, i, top, xpos) {
		let isTrue = expected > 0.9999999
		let neurons = this.props.net.layers[0].neurons;
		let r = neurons[0] * 255;
		let g = neurons[1] * 255;
		let b = neurons[2] * 255;
		let color = "rgb(" + r + "," + g + "," + b + ")"	
		let above50 = this.props.net.layers[this.props.net.layers.length - 1].neurons[this.maxOutputIndex] > 0.5	
		return (
			<div 
				className = {"Expected" + (isTrue ? "True" : "False")}
				key = {"EXPECTED" + i}
				style = {{
					top: this.headerH + (top + i * this.space + this.neuronW / 2 - 10) + "px", 
					left: (xpos + (isTrue ? -1 : 0) + (this.props.showBias ? 2 : 1) * this.state.matrixW + this.state.matrixW / 2 + 7) + "px",
				}}>
				{isTrue ? "\u25C0" : "\u25C1 "}&nbsp;
				{isTrue ? <div 
					className = {"ExpectedCheck" + (this.maxOutputIndex === i ? (above50 ? "Yes" : "Maybe") : "No")}>
						{this.maxOutputIndex === i ? "\u2714" : "\u2718"}
					</div> : null
				}
				{isTrue ? <div 
					className = "ExpectedColor" 
					key = {"EXPECTED_COLOR_GRAPH" + i}
					style = {{backgroundColor: color}}
					/>	: null
				}
				
					
				{COLORS[i]}
			</div>
		)
	}


	renderMatrixExpected(expected, i, top, xpos) {
		let isTrue = expected > 0.9999999
		let neurons = this.props.net.layers[0].neurons;
		let r = neurons[0] * 255;
		let g = neurons[1] * 255;
		let b = neurons[2] * 255;
		let color = "rgb(" + r + "," + g + "," + b + ")"			
		return (
			<div 
				className = {"Expected" + (isTrue ? "True" : "False")}
				key = {"MATRIX_EXPECTED" + i}
				style = {{
					top: this.headerH + (top + i * this.matrixH + 4) + "px", 
					left: (xpos + (isTrue ? -1 : 0) + this.state.matrixW / 2 + 7) + "px",
				}}>
				{isTrue ? "\u25C0" : "\u25C1 "}&nbsp;
				{isTrue ? <div 
					className = {"ExpectedCheck" + (this.maxOutputIndex === i ? "Yes" : "No")}>
						{this.maxOutputIndex === i ? "\u2714" : "\u2718"}
					</div> : null
				}				
				{isTrue ? <div 
					className = "ExpectedColor" 
					key = {"EXPECTED_COLOR_MATRIX" + i}
					style = {{backgroundColor: color}}
					/>				
					 : null}
				{COLORS[i]}
			</div>
		)
	}


	// render bias --------------------------------------------------------------------------------


	renderGraphBias(bias, layerNumber, xpos, ypos) {
		let jsx = []
		if (layerNumber > 0) {
			for (let i = 0; i < bias.length; i++) {
				let b = bias[i]
				let rgb = this.getWeightColor(b)
				jsx.push(
					<div 
						className = "Bias" 
						key = {"GRAPH_BIAS" + layerNumber + "-" + i}
						style = {{
							top: this.headerH + (ypos + i * this.space) + "px", 
							left: xpos + "px",
							width: this.neuronW * 2 + "px",
							height: this.neuronW + "px",
							borderRadius: this.neuronW / 2 + "px",
							background: "rgb(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + ")",
							color: Math.abs(b) > 4 ? "white" : "black"
							}}>
						{b.toFixed(this.state.precision)}
					</div>
				)
			}
		}
		return jsx;
	}


	renderMatrixBias(bias, layerNumber, xpos) {
		let jsx = []
		if (layerNumber > 0) {
			for (let i = 0; i < bias.length; i++) {
				let b = bias[i]
				let rgb = this.getWeightColor(b)
				jsx.push(
					<div 
						className = "MatrixElement" 
						key = {"MATRIX_BIAS" + layerNumber + "-" + i}
						style = {{
							left: xpos, 
							top: this.headerH + i * this.matrixH - 35,
							width: this.state.matrixW,
							height: this.matrixH,
							background: "rgb(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + ")",
							color: Math.abs(b) > 4 ? "white" : "black"
						}}>
						{b.toFixed(this.state.precision)}
					</div>
				)
			}
		}
		return jsx;
	}	


	// render weights and connections ------------------------------------------------------------------------


	renderGraphConnections(layer, layerNumber, xpos, ypos, xposPrev, yposPrev) {
		let jsx = []
		for (let row = 0; row < layer.neurons.length; row++) {
			for (let col = 0; col < layer.weights[0].length; col++) {
				let value = layer.weights[row][col]
				let rgb = this.getWeightColor(value)
				let height = (ypos + row * this.space) - (yposPrev + col * this.space)
				let width = xpos - xposPrev - (this.props.showBias && layerNumber > 1 ? this.neuronW : 0) - this.neuronW + 10
				jsx.push(
					<div className = "Connection"
						key = {"CONNECTION" + layerNumber + "-" + row + "-" + col}
						style = {{
							top: this.headerH + ((yposPrev + col * this.space) + this.neuronW / 2) + "px", 
							left: (xposPrev + this.neuronW / 1) + (this.props.showBias && layerNumber > 1 ? this.neuronW : 0) - 5 + "px", 
							width: width + "px", 
							height: Math.abs(height) + "px",
							transform: 
								"skewY(" + (Math.atan(height / width) * 180 / Math.PI) + "deg)" +
								"translateY(" + (height < 0 ? "-" : "") + "50%)", 
							borderTop: Math.abs(value / 2) + "px solid " + 
								"rgb(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + ")",
						}}
					/>
				)
			}
		}
		return jsx
	}

	
	renderMatrixWeights(layer, layerNumber, xpos) {
		let jsx = []
		for (let row = 0; row < layer.neurons.length; row++) {
			for (let col = 0; col < layer.weights[row].length; col++) {
				let value = layer.weights[row][col]
				let rgb = this.getWeightColor(value)
				jsx.push(
					<div 
						className = "MatrixElement" 
						key = {"WEIGHT" + layerNumber + "-" + row + "-" + col}
						style = {{
							left: xpos + (col * this.state.matrixW), 
							top: this.headerH + (row * this.matrixH) - 35,
							width: this.state.matrixW,
							height: this.matrixH,							
							background: "rgb(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + ")",
							color: Math.abs(value) > 4 ? "white" : "black"
						}}>
						{value.toFixed(this.state.precision)}
					</div>
				)
			}
		}
		return jsx;
	}		


	// render Neurons --------------------------------------------------------------------------------


	renderGraphNeurons(layer, layerNumber, xpos, ypos) { 
		let jsx = []
		for (let i = 0; i < layer.neurons.length; i++) {
			let n = layer.neurons[i]
			let c = Math.trunc(160 * (1 - n)) + 60
			jsx.push(
				<div 
					className = "Neuron" 
					key = {"NEURON" + i}
					style = {{
						top: this.headerH + (ypos + i * this.space) + "px", 
						left: xpos + "px",
						width: this.neuronW + "px",
						height: this.neuronW + "px",
						borderRadius: this.neuronW / 2 + "px",
						background: "rgb(" + c + "," + c + "," + c + ")",
						color: n > 0.3 ? "white" : "black"
						}}>
					{n.toFixed(2)}
				</div>
			)
			if (layerNumber === this.props.net.layers.length - 1) {
				jsx.push(
					this.renderGraphExpected(this.props.app.target[i], i, ypos, xpos)
				)
			}
		}
		return jsx;
	}


	renderMatrixNeurons(layer, layerNumber, xpos) {
		let jsx = []
		let nLayers = this.props.net.layers.length

		for (let i = 0; i < layer.neurons.length; i++) {
			let n = layer.neurons[i]
			let c = Math.trunc(160 * (1 - n)) + 60
			jsx.push(
				<div 
					className = "MatrixElement" 
					key = {"NEURON" + layerNumber + "-" + i}
					style = {{
						left: xpos, 
						top: this.headerH + i * this.matrixH - 35,
						width: this.state.matrixW,
						height: this.matrixH,
						background: "rgb(" + c + "," + c + "," + c + ")",
						color: n > 0.3 ? "white" : "black"
					}}>
					{n.toFixed(2)}
				</div>
			)
			if (layerNumber === nLayers - 1) {
				jsx.push(
					this.renderMatrixExpected(this.props.app.target[i], i, 0 - 35, xpos + this.state.matrixW * (this.props.showBias ? 2 : 1)),
				)
			}	
		}
		return jsx;
	}	


	// render Background -----------------------------------------------------------------------------


	renderGraphBack(layerNumber, xpos, xposPrev, layer) {
		let jsx = []
		jsx.push(
			this.renderBack(
				"GRAPH_LAYER_BACK" + layerNumber,
				xpos - this.state.matrixW / 2,
				(layerNumber === 0 ? this.inputW : 0) + (this.props.showBias ? (layerNumber === 0 ? 2 : 3) * this.state.matrixW : 2 * this.state.matrixW),
				this.maxNeurons * this.space + this.headerH + this.state.matrixW / 2 - 50,
				"", layerNumber, false, false, false
			)
		)
		if (layerNumber > 0) {
			jsx.push(
				this.renderBack(
					"GRAPH_WEIGHTS_BACK" + layerNumber, 
					xposPrev - this.state.matrixW / 2 + (this.props.showBias ? (layerNumber === 1 ? 2 : 3) : 2) * this.state.matrixW,
					(layer.weights[0].length + 1) * this.state.matrixW,
					this.maxNeurons * this.space + this.headerH + this.state.matrixW / 2 - 50,
					"", layerNumber, false, false, false				
				)
			)
		}
		if (layerNumber === this.props.net.layers.length - 1) {
			jsx.push(
				this.renderBack(
					"GRAPH_EXPECTED_BACK" + layerNumber, 
					(xpos + (this.props.showBias ? 3 : 2) * this.state.matrixW) - this.state.matrixW / 2, 
					130, 
					this.maxNeurons * this.space + this.headerH + this.state.matrixW / 2 - 50, 
					"", layerNumber, false, false, true
				)
			)
		}		
		return jsx
	}


	renderMatrixBack(layerNumber, xpos, layer) {
		let jsx = []
		jsx.push(
			this.renderBack(
				"MATRIX_LAYER_BACK" + layerNumber,
				(xpos + (layerNumber === 0 ? 0 : layer.weights[0].length + 1) * this.state.matrixW) - this.state.matrixW / 2,
				(layerNumber === 0 ? this.inputW : 0) + (this.props.showBias ? (layerNumber === 0 ? 2 : 3) * this.state.matrixW : 2 * this.state.matrixW),
				this.maxNeurons * this.matrixH + this.headerH + this.state.matrixW / 2 - 40,
				"", layerNumber, false, false, false
			)
		)
		if (layerNumber > 0) {
			jsx.push(
				this.renderBack(
					"MATRIX_WEIGHTS_BACK" + layerNumber, 
					xpos - this.state.matrixW / 2,
					(layer.weights[0].length + 1) * this.state.matrixW,
					this.maxNeurons * this.matrixH + this.headerH + this.state.matrixW / 2 - 40,
					"", layerNumber, false, false, false				
				)
			)	
		}
		if (layerNumber === this.props.net.layers.length - 1) {
			xpos = xpos + (layer.weights[0].length + 1) * this.state.matrixW
			jsx.push(
				this.renderBack(
					"MATRIX_EXPECTED_BACK" + layerNumber, 
					(xpos + (this.props.showBias ? 3 : 2) * this.state.matrixW) - this.state.matrixW / 2, 
					130, 
					this.maxNeurons * this.matrixH + this.headerH + this.state.matrixW / 2 - 40, 
					"", layerNumber, false, false, true
				)
			)
		}		
		return jsx
	}


	renderLayerHeaderBack(layerNumber, xpos, layer) {
		let jsx = []
		let header = 100
		jsx.push(
			this.renderBack(
				"HEADER_LAYER_BACK" + layerNumber,
				(xpos + (layerNumber === 0 ? 0 : layer.weights[0].length + 1) * this.state.matrixW) - this.state.matrixW / 2,
				(layerNumber === 0 ? this.inputW : 0) + (this.props.showBias ? (layerNumber === 0 ? 2 : 3) * this.state.matrixW : 2 * this.state.matrixW),
				header,
				this.getLayerLabel(layerNumber), layerNumber, true, false, false
			)
		)
		if (layerNumber > 0) {
			jsx.push(
				this.renderBack(
					"HEADER_WEIGHTS_BACK" + layerNumber, 
					xpos - this.state.matrixW / 2,
					(layer.weights[0].length + 1) * this.state.matrixW,
					header,
					"", layerNumber, false, true, false			
				)
			)	
		}
		if (layerNumber === this.props.net.layers.length - 1) {
			xpos = xpos + (layer.weights[0].length + 1) * this.state.matrixW
			jsx.push(
				this.renderBack(
					"HEADER_EXPECTED_BACK" + layerNumber, 
					(xpos + (this.props.showBias ? 3 : 2) * this.state.matrixW) - this.state.matrixW / 2, 
					130, 
					header,
					"Expected", layerNumber, false, false, false
				)
			)
		}		
		return jsx
	}


	// render Layer --------------------------------------------------------------------------------


	renderGraphLayer(layer, layerNumber, xpos, ypos, xposPrev, yposPrev) {
		let jsx = []
		jsx.push(
			this.renderGraphConnections(layer, layerNumber, xpos, ypos - 40, xposPrev, yposPrev - 40),
			this.renderGraphNeurons(layer, layerNumber, xpos, ypos - 40),
			this.renderGraphBack(layerNumber, xpos, xposPrev, layer)
		)
		if (this.props.showBias) {
			jsx.push(
				this.renderGraphBias(layer.bias, layerNumber, xpos, ypos - 40)
			)
		}
		return jsx;
	}


	renderMatrixLayer(layer, layerNumber, xpos) {
		let jsx = []
		let columns = layer.weights[0].length
		jsx.push(
			this.renderMatrixWeights(layer, layerNumber, xpos),
			this.renderMatrixNeurons(layer, layerNumber, xpos + (columns + 1) * this.state.matrixW),
			this.renderMatrixBack(layerNumber, xpos, layer)
		)
		if (this.props.showBias) {
			jsx.push(
				this.renderMatrixBias(layer.bias, layerNumber, xpos + (columns + 2) * this.state.matrixW)
			)
		}
		return jsx;
	}


	renderLayerHeader(layer, layerNumber, xpos) {
		let jsx = []
		jsx.push(
			this.renderLayerHeaderBack(layerNumber, xpos, layer)
		)
		return jsx;
	}



	// render color ---------------------------------------------------------------------------------
	

	renderGraphColor(ypos) {
		let neurons = this.props.net.layers[0].neurons;
		let r = neurons[0] * 255;
		let g = neurons[1] * 255;
		let b = neurons[2] * 255;
		return (
			<div 
				className = "GraphColor" 
				key = "GRAPH_C"
				style = {{top: ypos + 20 + "px"}}>
				<div className = "GraphColorRGB" key = "GraphRGB1">{r}</div>
				<div className = "GraphColorRGB" key = "GraphRGB2">{g}</div>
				<div className = "GraphColorRGB" key = "GraphRGB3">{b}</div>
			</div>
		)
	}



	renderMatrixColor(ypos) {
		let neurons = this.props.net.layers[0].neurons;
		let r = neurons[0] * 255;
		let g = neurons[1] * 255;
		let b = neurons[2] * 255;
		return (
			<div 
				className = "GraphColor" 
				key = "MATRIX_C"
				style = {{top: ypos + 26 + "px"}}>
				<div className = "MatrixColorRGB" key = "MatrixRGB1">{r}</div>
				<div className = "MatrixColorRGB" key = "MatrixRGB2">{g}</div>
				<div className = "MatrixColorRGB" key = "MatrixRGB3">{b}</div>
			</div>
		)
	}



	// render matrix or graph --------------------------------------------------------------------------------


	renderLayers() {
		let jsx = []
		let xpos = 2 * this.state.matrixW + this.inputW

		jsx.push(
			this.renderLayerHeader(this.props.net.layers[0], 0, 0)
		)			

		for (let i = 1; i < this.props.net.layers.length; i++) {
			let layer = this.props.net.layers[i]
			let columns = layer.weights[0].length
			jsx.push(
				this.renderLayerHeader(layer, i, xpos)
			)			
			xpos += (columns + (this.props.showBias ? 4 : 3)) * this.state.matrixW
		}
		return jsx;
	}	


	renderGraph() {
		if (!this.props.showGraph) {
			return null
		}
		let jsx = []
		
		let xpos = 0 
		let ypos = (this.maxNeurons - this.props.net.layers[0].neurons.length) / 2 * this.space
		jsx.push(this.renderGraphColor(ypos))
		jsx.push(
			this.renderGraphNeurons(this.props.net.layers[0], 0, xpos + this.inputW, ypos - 40),
			this.renderGraphBack(0, xpos, 0, this.props.net.layers[0])
		)
		xpos = this.inputW
		for (let i = 1; i < this.props.net.layers.length; i++) {
			let layer = this.props.net.layers[i]
			let columns = layer.weights[0].length
			let yposPrev = ypos
			let xposPrev = xpos
			ypos = (this.maxNeurons - layer.neurons.length) / 2 * this.space
			xpos += (columns + (this.props.showBias ? (i === 1 ? 3 : 4) : 3)) * this.state.matrixW
			jsx.push(
				this.renderGraphLayer(layer, i, xpos, ypos, xposPrev, yposPrev) 
			)			
		}
		return jsx;		
	}	


	renderMatrix() {
		if (!this.props.showMatrix) {
			return null
		}
		let jsx = []
		jsx.push(this.renderMatrixColor(0))
		jsx.push(
			this.renderMatrixNeurons(this.props.net.layers[0], 0, this.inputW),
			this.renderMatrixBack(0, 0, this.props.net.layers[0])
		)
		let xpos = 2 * this.state.matrixW + this.inputW
		for (let i = 1; i < this.props.net.layers.length; i++) {
			let layer = this.props.net.layers[i]
			let columns = layer.weights[0].length
			jsx.push(
				this.renderMatrixLayer(layer, i, xpos)
			)			
			xpos += (columns + (this.props.showBias ? 4 : 3)) * this.state.matrixW
		}
		return jsx;		
	}


	// main render --------------------------------------------------------------------------------


	renderShowGraphButton(ypos, matrixHeight) {
		if (!this.props.app.state.showGraph) {
			if (this.props.app.state.showMatrix) {
				ypos += matrixHeight
			}
			return (
				<div 
					className = {"DBTabItem"}
					style = {{top: ypos + 10, left: 20}}
					onClick = {() => this.props.app.setState({showGraph: !this.props.app.state.showGraph})}
					>
					<div className = "DBTabCheck">{"\u2714"}</div>
					Show Graph
				</div>
			)
		}
	}


	renderShowMatrixButton(ypos) {
		if (!this.props.app.state.showMatrix) {
			return (
				<div 
					className = {"DBTabItem"}
					style = {{top: ypos + 10, left: 20}}
					onClick = {() => this.props.app.setState({showMatrix: !this.props.app.state.showMatrix})}
					>
					<div className = "DBTabCheck">{"\u2714"}</div>
					Show Matrix
				</div>
			)
		}
	}


	render() {
		this.maxNeurons = this.getMaxNeurons()
		this.maxOutputIndex = this.getHighestOutputIndex()
		let left = this.state.matrixW / 2 + 20
		let top = 20
		let header = 100
		let matrixTop = (!this.props.showGraph ? top : this.maxNeurons * this.space + this.headerH + top + this.state.matrixW / 2 - 50) 

		return (
			<div className = "Net">
				<div className = "Layers"
					style = {{
						top: top + "px",
						left: left + "px",
					}}>
					{this.renderLayers()}
				</div>
				{this.renderShowGraphButton(top + header, this.maxNeurons * this.matrixH + this.space)}
				<div 
					className = "Graph" 
					style = {{
						top: (top + header) + "px",
						left: left + "px",
					}}>
					{this.renderGraph()}
				</div>
				{this.renderShowMatrixButton(header + matrixTop)}
				<div 
					className = "Matrix" 
					style = {{
						top: (matrixTop + header) + "px",
						left: left + "px",
					}}>
					{this.renderMatrix()}
				</div>
			</div>
		)
	}


}